import React, { useEffect, Fragment, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { BasicParagraph, H2 } from '../../components/basic/Text';
import styled from 'styled-components/macro';
import { useMessageGetter } from 'react-message-context';
import PaddedContent from '../../components/housing/PaddedContent';
import { blackLogo } from '../../assets';
import { DeviceSize } from '../../components/basic/DeviceSize';
import { Button } from '../../components/common';

const ContactRequestSuccessPage = () => {
  const t = useMessageGetter('message.success');
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      setShouldRedirect(true);
    }, 5000);
    return () => clearTimeout(id);
  }, []);

  if (shouldRedirect) return <Redirect push to="/" />;

  const returnToHome = () => {
    setShouldRedirect(true);
  };

  return (
    <Fragment>
      <Container>
        <PaddedContent paddingTop="50px">
          <Logo src={blackLogo} alt="M2 logo" aria-label="M2-Kodit logo" />
          <H2>{t('success')}</H2>
          <BasicParagraph>{t('description')}</BasicParagraph>
          <CustomButton onClick={returnToHome} primary>
            {t('button')}
          </CustomButton>
        </PaddedContent>
      </Container>
    </Fragment>
  );
};

const Container = styled.div`
  height: 100vh;
  text-align: center;
  background-color: ${(props) => props.theme.colors.peppermintLight};
`;

const Logo = styled.img`
  margin: 50px;
  width: 140px;
  @media ${DeviceSize.mobileL} {
    width: 100px;
  }
`;

const CustomButton = styled(Button)`
  margin-top: 50px;
`;

export default ContactRequestSuccessPage;
